<template>
  <!--资格校验页-->
  <div class="qualificationCheck">
    <el-dialog
      title="提示"
      :show-close="false"
      :visible.sync="dialogVisible"
      width="453px"
      custom-class="qualification-check-dialog"
      center>
      <div class="message-container">
        <div class="img-box">
          <img src="../../../../assets/img/warnIcon.svg" alt="">
        </div>
        <span class="message">{{message}}</span>
      </div>
      <span slot="footer" class="dialog-footer">
					<el-button v-if="showCancelButton" @click="goBack">{{cancelButtonText}}</el-button>
					<el-button type="primary" @click="goConfirm" :disabled="showCountdown && countDown > 0">{{confirmButtonText}}<span v-if="showCountdown && countDown > 0">（{{countDown}}s）</span></el-button>
				</span>
    </el-dialog>
  </div>
</template>

<script>
import {
  decryptByAES
} from '@/utils/utils'
import {
  fetchData,
} from '@/utils/ajax';
import {Loading, MessageBox} from "element-ui";
let int = null
export default {
  name: "qualificationCheck",
  data() {
    return {
      baseInfo: JSON.parse(sessionStorage.getItem('baseInfo')),
      timerNum: 3, // 网络超时重试次数
      loading: null,
      verifyType: -1, // 1资格校验（人社事项资格校验）、2资格校验（参保地资格校验）、4账号证件类型校验、5、人社多个“个人编码”校验、6申请人年龄校验、-2网络原因（可重试）、-3网络原因（超过次数不可重试）
      dialogVisible: false,
      message: '',
      confirmButtonText: '',
      cancelButtonText: '',
      showCancelButton: false,
      qualificationVerifyUrl: '',
      showCountdown: false,
      countDown: 3
    };
  },
  computed: {},
  methods: {
    goBack() {
      this.loading.close();
      this.$router.push('/graphicInstructions');
    },
    // 确定按钮
    goConfirm() {
      if (this.verifyType == 4) { // 账号证件类型校验不通过
        this.confirmModify();
      } else if (this.verifyType == -2) { // 网络原因（可重试）
        this.loading = Loading.service();
        this.getQualificationList();
      } else { // 其余情况
        this.goBack()
      }
    },
    timeout() {
      // 超过了重试次数
      if (this.timerNum <= 0) {
        this.verifyType = -3
        this.message = '由于网络原因，连接超时，请稍后重试。'
        this.showCancelButton = false
        this.confirmButtonText = '稍后重试'
        this.showCountdown = false
        this.dialogVisible = true
        return false
      }
      this.timerNum--
      this.verifyType = -2
      this.message = '由于网络原因，连接超时，您可点击继续按钮进行重试。'
      this.showCancelButton = true
      this.cancelButtonText = '稍后重试'
      this.confirmButtonText = '继续办理'
      this.showCountdown = true
      this.dialogVisible = true
      this.countDown = 3
      int = setInterval(() => {
        if(this.countDown > 0) {
          this.countDown--
        } else {
          clearInterval(int)
          int = null
        }
      }, 1000)
    },
    getConfiguration() {
      this.loading = Loading.service();
      let unionServQualificationList = this.baseInfo?.unionServQualificationList;

      if (unionServQualificationList && unionServQualificationList?.length) {
        for (let i = 0, unionServQualificationListLength = unionServQualificationList.length; i < unionServQualificationListLength; i++) {
          if (unionServQualificationList[i]?.qualificationVerifyUrl) {
            this.qualificationVerifyUrl = unionServQualificationList[i].qualificationVerifyUrl
            this.getQualificationList();
          }
        }
      } else {
        this.loading.close();
        this.$router.push('/questionNair'); //跳转导办页
      }
    },
    getQualificationList() {
      if (!this.qualificationVerifyUrl) {
        return false
      }
      fetchData(this.qualificationVerifyUrl, {}, 'get', (res) => {
        this.loading.close();
        if (+res.status == 200) {
          if (res.data?.verifyResult == false) {
            this.verifyType = res.data.verifyType
            this.popUp(res.data.verifyType, res.data.verifyErrMsg);
          } else {
            this.$router.push('/questionNair');
          }
        } else {
          this.timeout()
        }
      });
    },
    /**
     * @description: 弹窗
     */
    popUp(type,msg) {
      if (type == 2){
        this.message = '您的参保地不在本次“退休一件事”办理范围，请到对应参保地进行办理。'
        this.showCancelButton = false
        this.confirmButtonText = '我知道了'
      }else if (type == 4) {
        this.message = '目前仅支持大陆居民身份证类型办理该事项，若要继续办理，可前往统一认证平台修改申请主体信息。'
        this.showCancelButton = true
        this.cancelButtonText = '取消'
        this.confirmButtonText = '前往统一身份认证'
      } else { // type == 1 || type == 5 || type == 6
        this.message = msg
        this.showCancelButton = false
        this.confirmButtonText = '我知道了'
      }
      this.showCountdown = false
      this.dialogVisible = true
    },
    confirmModify() {
      MessageBox.confirm("本次修改将于统一认证进行修改，是否继续？", "提示", {
        showClose: false,
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: 'warning',
      }).then(() => {
        this.handleSure();
      }).catch(() => {
      });
    },
    handleSure() {
      MessageBox.confirm("请在统一认证页面完成信息修改后在此页面进行确认", "提示", {
        showClose: false,
        confirmButtonText: "我已修改",
        showCancelButton: false,
        type: 'warning',
      }).then(() => {
        window.location.href = `${process.env.BASE_URL}entering.html?rURL=${encodeURIComponent(window.location.href)}`;
      }).catch(() => {
      });
      window.open('https://tyrz.gd.gov.cn/pscp/sso/static/manage/info?key=modify_basi');
    },
    // 服务对象校验
    // 若一件事服务对象不包含自然人，账号类型是自然人，系统提示。
    // 若一件事服务对象不包含非自然人，账号类型是法人，系统提示。
    checkServiceObject() {
      let userInfo =  JSON.parse(decryptByAES(sessionStorage.getItem('userInfo'))).userInfo
      if (this.baseInfo.isEnterprise == 1 && userInfo.uType == 1
        || this.baseInfo.isEnterprise == 0 && userInfo.uType == 2) {
        this.message = `此一件事服务对象仅支持${this.baseInfo.typeServiceObjVoList.map(el=>el.serviceObjectName).join('、')}，当前账号不符合，无法申请。`
        this.showCancelButton = false
        this.confirmButtonText = '我知道了'
        this.showCountdown = false
        this.dialogVisible = true
        return false
      } else {
        return true
      }
    }
  },
  created() {
    let checkRes = this.checkServiceObject();
    if (checkRes) {
      this.getConfiguration();
    }
  },
  beforeDestroy() {
    clearInterval(int)
    int = null
  },
  mounted() {

  }
};
</script>

<style lang="scss" scoped>
/deep/.qualification-check-dialog.el-dialog{
  .el-dialog__header{
    border-bottom:1px solid #EEEEEE;
    margin: 0 20px;
    padding: 10px 0;
    text-align: left;
    .el-dialog__title{
      font-size: 20px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      color: #45484B;
      line-height: 30px;
    }
  }
  .el-dialog__body{
    padding: 20px;
    .message-container{
      display: flex;
      align-items: flex-start;
      .img-box{
        height: 24px;
        margin-right: 10px;
      }
      .message{
        font-size: 16px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        color: #45484B;
        line-height: 24px;
      }
    }
  }
  .el-dialog__footer{
    padding: 20px;
    text-align: right;
  }
}
</style>
